module.exports = __webpack_public_path__ + "img/Group 97828.778a7b4a.png";